import React, { Component } from "react";
import { NavigationType } from "@custom-types/NavigationType";
import { HeaderType } from "@custom-types/HeaderType";
import ScreenWrapper from "@components/wrapper/ScreenWrapper";
import Header from "@components/header/Header";
import Container from "@base/Container";
import { connect } from "react-redux";
import i18n from "@i18n/i18n";
import { Client } from "@custom-types/Client";
import { REDEEMABLE, ExperienceStatus, RedeemableType, ExperiencesRedux } from "@custom-types/ExpercienceModel";
import { Route } from "@react-navigation/native";
import { FlatList, View } from "react-native";
import RedeemableWideCard from "../../experiences/components/RedeemableWideCard";
import ExperienceService from "@core/services/ExperienceService";
import { CustomMessageModel } from "@custom-types/CustomMessageModel";
import { Chat } from "@custom-types/Chat";
import { MessagesNavigatorScreens } from "@navigation/MessagesNavigator";
import BotCard from "@base/BotCard";
import { ExperienceModuleType, ModuleControlService } from "@core/services/ModuleControlService";
import MerchantSection from "@screens/experiences/components/MerchantSection";

interface Props {
    navigation: NavigationType;
    route: Route<string, { sectionType?: RedeemableType }>;
    client: Client;
    experiences: ExperiencesRedux;
    customMessage: CustomMessageModel;
    selectedChat: Chat;
}

interface State {
    type?: RedeemableType;
}

const { t } = i18n;

export class _SelectRedeemableActionsScreen extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.renderItem = this.renderItem.bind(this);
        this.onSelectRedeemable = this.onSelectRedeemable.bind(this);
        this.state = {
            type: this.props.route?.params?.sectionType || RedeemableType.TICKET,
        };
    }

    async onSelectRedeemable(redeemable: REDEEMABLE) {
        const resp = await ExperienceService.getInstance().getTransferDataRedeemable(
            redeemable?._id,
            this.props.selectedChat.to._id,
        );
        if (resp) {
            this.props.navigation.navigate(MessagesNavigatorScreens.ConfirmTransferRedeemable.routeName, {
                redeemable: redeemable,
                client_to: this.props.selectedChat.to,
                data: resp,
            });
        }
    }

    renderItem = ({ item }) => {
        return (
            <RedeemableWideCard
                onPress={this.onSelectRedeemable}
                redeemable={item}
                navigation={this.props.navigation}
            />
        );
    };

    filterRedeemables() {
        return this.props.experiences[this.state.type].docs.filter((r: REDEEMABLE) => {
            return (
                r.redeemableOption.transferable &&
                r.status !== ExperienceStatus.EXPIRED &&
                r.status !== ExperienceStatus.USED
            );
        });
    }

    render() {
        return (
            <ScreenWrapper>
                <Header title={t(this.state.type)} type={HeaderType.Light} {...this.props} />
                <Container style={{ flex: 1 }}>
                    {ModuleControlService.getInstance().getActiveExperienceModuleType(
                        ExperienceModuleType.exclusive,
                    ) && (
                        <MerchantSection
                            navigation={this.props.navigation}
                            containerStyle={{ paddingTop: 10, paddingBottom: 25 }}
                        ></MerchantSection>
                    )}
                    <FlatList
                        data={this.filterRedeemables()}
                        renderItem={this.renderItem}
                        keyExtractor={(item) => item._id}
                        contentContainerStyle={{ paddingTop: 10, zIndex: 9999 }}
                        initialNumToRender={5}
                        maxToRenderPerBatch={10}
                        showsHorizontalScrollIndicator={false}
                        ListHeaderComponent={
                            this.filterRedeemables()?.length > 0 && (
                                <BotCard message={t("bot_message_select_redeemable", { type: this.state.type })} />
                            )
                        }
                        ListEmptyComponent={
                            <BotCard message={t("bot_message_empty_redeemable", { type: this.state.type })} />
                        }
                    />
                </Container>
            </ScreenWrapper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        client: state.auth.client,
        experiences: state.experiences,
        customMessage: state.chat.customMessage,
        selectedChat: state.chat.selected,
    };
};

const mapDispatchToProps = (dispatch) => ({});

const SelectRedeemableActionsScreen = connect(mapStateToProps, mapDispatchToProps)(_SelectRedeemableActionsScreen);

export default SelectRedeemableActionsScreen;
